import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, MenuItem, TextField, Typography } from '@material-ui/core'
import React from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useAlert } from '../../hooks/useAlert';
import useDictionaries from '../../hooks/useDictionaries';

const ContractModal = ({ services, abiturInfo, documents, institutions }) => {
    const [open, setOpen] = React.useState(false);
    const {
        handleSubmit,
        reset,
        control,
    } = useForm();
    const showAlert = useAlert();
    const { dictionary: { languages } } = useDictionaries({});

    const [isLoading, setIsLoading] = React.useState(false);
    const [isHasContract, setIsHasContract] = React.useState(false);
    const [selectedLanguage, setSelectedLanguage] = React.useState("none");
    const [contract, setContract] = React.useState({});

    const handleLanguageChange = (event) => {
        setSelectedLanguage(event.target.value);
        onDownloadApplication(event.target.value)
    };

    const handleClose = () => {
        setOpen(false);
    };

    React.useEffect(() => {
        if (abiturInfo.id) {
            services.contract.checkContractByUserId(abiturInfo.id)
                .then(response => {
                    setIsHasContract(response.data)
                    response.data === true && services.contract.getContractByUserId(abiturInfo.id)
                        .then(response => {
                            setContract(response.data)
                        })

                })
                .catch(error => console.error('Error checking contract:', error));
        }

        reset({
            email: abiturInfo.email,
            fullnameKz: `${abiturInfo.surname} ${abiturInfo.name} ${abiturInfo.patronymic ? abiturInfo.patronymic : ""}`,
            fullnameEn: abiturInfo.surnameInLatin + " " + abiturInfo.nameInLatin,
            birthday: abiturInfo.dateOfBirth,
            iin: abiturInfo.iin,
            address: abiturInfo.factAddress,
            phoneNumber: abiturInfo.phoneNumber,
            isForeign: abiturInfo.citizenship && abiturInfo.citizenship.id === 86 ? false : true,
            barcode: abiturInfo.barCode,
            //Doc
            docType: abiturInfo.identityDocumentType,
            authorityType: abiturInfo.documentIssuingAuthority,
            number: abiturInfo.identityDocumentNumber,
            givenAt: abiturInfo.identityDocumentIssueDate,
            //Parent
            parentFullname: abiturInfo.firstParentSurname + " " + abiturInfo.firstParentName + " " + abiturInfo.firstParentPatronymic,
            parentDocType: {},
            parentDocInstitution: {},
            parentDocNumber: "",
            parentDocGivenAt: "",
            parentEmail: "",
            //Admission
            admissionYear: localStorage.getItem("AdmissionOfYear"),
            degree: abiturInfo.academicDegree,
            goep: abiturInfo.educationalProgram?.educationalProgramGroup,
            ep: abiturInfo.educationalProgram,
            awardedDegree: abiturInfo.educationalProgram?.awardedDegreeDtoResponse,
            isGrant: abiturInfo.studyType === 2 ? true : false,
        });
    }, [abiturInfo, reset, services.contract]);

    const generateRequestApplicationData = (abiturInfo, lang) => ({
        "userId": abiturInfo.id,
        "lang": lang,
        "fullnameRu": `${abiturInfo.surname} ${abiturInfo.name} ${abiturInfo.patronymic ? abiturInfo.patronymic : ""}`,
        "fullnameEn": abiturInfo.surnameInLatin + " " + abiturInfo.nameInLatin,
        "address": abiturInfo.factAddress,
        "phoneNumber": abiturInfo.phoneNumber,
        "abiturAdmissionInfo": {
            "goepNameKz": (abiturInfo.educationalProgram?.educationalProgramGroup.educationalProgramCode ? `${abiturInfo.educationalProgram?.educationalProgramGroup.educationalProgramCode} ` : null) + abiturInfo.educationalProgram?.educationalProgramGroup.nameKz,
            "goepNameRu": (abiturInfo.educationalProgram?.educationalProgramGroup.educationalProgramCode ? `${abiturInfo.educationalProgram?.educationalProgramGroup.educationalProgramCode} ` : null) + abiturInfo.educationalProgram?.educationalProgramGroup.name,
            "goepNameEn": (abiturInfo.educationalProgram?.educationalProgramGroup.educationalProgramCode ? `${abiturInfo.educationalProgram?.educationalProgramGroup.educationalProgramCode} ` : null) + abiturInfo.educationalProgram?.educationalProgramGroup.nameEn,
            "epNameKz": (abiturInfo.educationalProgram.code ? `${abiturInfo.educationalProgram.code} ` : null) + abiturInfo.educationalProgram.nameKz,
            "epNameRu": (abiturInfo.educationalProgram.code ? `${abiturInfo.educationalProgram.code} ` : null) + abiturInfo.educationalProgram.name,
            "epNameEn": (abiturInfo.educationalProgram.code ? `${abiturInfo.educationalProgram.code} ` : null) + abiturInfo.educationalProgram.nameEn,
            "degreeId": abiturInfo.academicDegree.id,
            "certificateNumber": abiturInfo.ikt,
            "examPoints": abiturInfo.examMark
        },
        "abiturAdditionalInfo": {
            "socialStatusNameRu": abiturInfo?.socialStatus ? abiturInfo?.socialStatus?.name : "нет",
            "socialStatusNameKz": abiturInfo?.socialStatus ? abiturInfo?.socialStatus?.nameKz : "жоқ",
            "socialStatusNameEn": abiturInfo?.socialStatus ? abiturInfo?.socialStatus?.nameEn : "no",
            "quotaNameRu": abiturInfo?.quota ? abiturInfo?.quota?.name : "нет",
            "quotaNameKz": abiturInfo?.quota ? abiturInfo?.quota?.nameKz : "жоқ",
            "quotaNameEn": abiturInfo?.quota ? abiturInfo?.quota?.nameEn : "no",
        }
    })

    const generateRequestContractData = (data, abiturInfo, requestDocType, requestInstitution) => ({
        "contractNumber": abiturInfo.barCode,
        "signedAt": new Date().toISOString().slice(0, 10),
        "abitur": {
            "userId": abiturInfo.id,
            "email": abiturInfo.email,
            "fullnameKz": data.fullnameKz,
            "fullnameEn": data.fullnameEn,
            "birthday": data.birthday,
            "iin": data.iin,
            "address": data.address,
            "phoneNumber": data.phoneNumber,
            "isForeign": data.isForeign,
            "barcode": data.barCode,
            "idCardInfo": {
                "typeId": data.docType.id,
                "typeEn": data.docType.nameEn,
                "typeKz": data.docType.nameKz,
                "typeRu": data.docType.name,
                "number": data.number,
                "givenAt": data.givenAt,
                "issuingAuthorityId": data.authorityType.id,
                "issuingAuthorityEn": data.authorityType.nameEn,
                "issuingAuthorityKz": data.authorityType.nameKz,
                "issuingAuthorityRu": data.authorityType.name
            },
            "abiturLegalRepresentative": {
                "fullname": data.parentFullname,
                "email": isUnder18 ? data.parentEmail : "",
                "idCardInfo": {
                    "typeId": isUnder18 ? requestDocType.id : "",
                    "typeEn": isUnder18 ? requestDocType.nameEn : "",
                    "typeKz": isUnder18 ? requestDocType.nameKz : "",
                    "typeRu": isUnder18 ? requestDocType.name : "",
                    "number": isUnder18 ? data.parentDocNumber : "",
                    "givenAt": isUnder18 ? data.parentDocGivenAt : new Date().toISOString().slice(0, 10),
                    "issuingAuthorityId": isUnder18 ? requestInstitution.id : "",
                    "issuingAuthorityEn": isUnder18 ? requestInstitution.nameEn : "",
                    "issuingAuthorityKz": isUnder18 ? requestInstitution.nameKz : "",
                    "issuingAuthorityRu": isUnder18 ? requestInstitution.name : ""
                },
                "iin": data.parentIIN ?? ""
            },
            "abiturAdmissionInfo": {
                "admissionYear": data.admissionYear,
                "goepNameKz": (data.goep.educationalProgramCode ? data.goep.educationalProgramCode : "") + " " + data.goep.nameKz,
                "goepNameRu": (data.goep.educationalProgramCode ? data.goep.educationalProgramCode : "") + " " + data.goep.name,
                "goepNameEn": (data.goep.educationalProgramCode ? data.goep.educationalProgramCode : "") + " " + data.goep.nameEn,
                "epNameKz": (data.ep.code ? data.ep.code : "") + " " + data.ep.nameKz,
                "epNameRu": (data.ep.code ? data.ep.code : "") + " " + data.ep.name,
                "epNameEn": (data.ep.code ? data.ep.code : "") + " " + data.ep.nameEn,
                "degreeId": data.degree.id,
                "degreeNameKz": data.degree.nameKz,
                "degreeNameRu": data.degree.name,
                "degreeNameEn": data.degree.nameEn,
                "awardedDegreeNameKz": data.awardedDegree.nameKz,
                "awardedDegreeNameRu": data.awardedDegree.name,
                "awardedDegreeNameEn": data.awardedDegree.nameEn,
                "grantCategoryKz": data.degree.nameKz,
                "grantCategoryRu": data.degree.name,
                "isGrant": data.isGrant
            }
        },
    });

    const onDownload = (data) => {
        const requestDocType = documents.find((doc) => doc.id === data.parentDocType.id);
        const requestInstitution = institutions.find((institution) => institution.id === data.parentDocInstitution.id);
        const requestData = generateRequestContractData(data, abiturInfo, requestDocType, requestInstitution);
        requestData.isHasQR = false;

        services.secretary.downloadContract(requestData).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");

            link.href = url;
            link.setAttribute("download", "Договор.docx");
            document.body.appendChild(link);
            link.click();
        })
    }

    const onSubmitSend = (data) => {
        const requestDocType = documents.find((doc) => doc.id === data.parentDocType.id);
        const requestInstitution = institutions.find((institution) => institution.id === data.parentDocInstitution.id);
        const requestData = generateRequestContractData(data, abiturInfo, requestDocType, requestInstitution);

        setIsLoading(true);
        services.secretary.createContract(requestData)
            .then((response) => {
                if (response.status === 200) {
                    setOpen(false);
                    showAlert("Договор успешно отправлен", "success");
                }
            })
            .finally(() => setIsLoading(false));
    }

    const onDownloadApplication = (lang) => {
        const requestData = generateRequestApplicationData(abiturInfo, lang);

        services.secretary.downloadApplication(requestData).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");

            link.href = url;
            if (lang === "ru") {
                link.setAttribute("download", "Заявление.docx");
            }
            else if (lang === "en") {
                link.setAttribute("download", "Application.docx");
            }
            else if (lang === "kz") {
                link.setAttribute("download", "Өтініш.docx");
            }
            else {
                link.setAttribute("download", "Application.docx");
            }
            document.body.appendChild(link);
            link.click();
        })
    }

    const renderGrid = (title, field) => {
        return (
            <Grid item style={{ width: "100%" }}>
                <Grid container spacing={2}>
                    <Grid item xs={4} style={{ marginLeft: "10px", display: "flex", justifyContent: "left", alignItems: "center" }}>
                        <Typography>
                            {title}
                        </Typography>
                    </Grid>
                    <Grid item xs={7}>
                        {field}
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    const calculateAge = (dateOfBirth) => {
        const birthDate = new Date(dateOfBirth);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDifference = today.getMonth() - birthDate.getMonth();
        if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    };

    const isUnder18 = calculateAge(abiturInfo.dateOfBirth) < 18;

    return (
        <>
            <Button
                type="submit"
                variant="contained"
                onClick={() => setOpen(true)}
            >
                Данные о договоре
            </Button>
            <Dialog
                open={open}
                onClose={handleClose}
                scroll={"paper"}
                maxWidth={"md"}
                aria-labelledby="contract-dialog-title"
                aria-describedby="contract-dialog-description"
            >
                <DialogTitle id="contract-dialog-title">Данные о договоре</DialogTitle>
                <form onSubmit={handleSubmit(onSubmitSend)}>
                    <DialogContent dividers={true}>
                        <DialogContentText
                            id="contract-dialog-description"
                            tabIndex={-1}
                        >
                            <Grid container spacing={2} style={{ color: "black" }}>
                                <Box width={"100%"} mb="30px">
                                    <Box style={{
                                        marginBottom: 10,
                                        display: "flex",
                                        justifyContent: "center"
                                    }}>
                                        <Typography variant="h5">Общая информация абитурента</Typography>
                                    </Box>
                                    {renderGrid(
                                        "ФИО на казахском",
                                        <Controller
                                            name="fullnameKz"
                                            control={control}
                                            render={({ field }) =>
                                                <Typography>{field?.value ?? ""}</Typography>
                                            }
                                        />,
                                    )}
                                    {renderGrid(
                                        "ФИО на английском",
                                        <Controller
                                            name="fullnameEn"
                                            control={control}
                                            render={({ field }) =>
                                                <Typography>{field?.value ?? ""}</Typography>
                                            }
                                        />,
                                    )}
                                    {renderGrid(
                                        "Дата рождения",
                                        <Controller
                                            name="birthday"
                                            control={control}
                                            render={({ field }) => (
                                                <Typography>{field?.value ?? ""}</Typography>
                                            )}
                                        />
                                    )}
                                    {renderGrid(
                                        "ИИН",
                                        <Controller
                                            name="iin"
                                            control={control}
                                            render={({ field }) =>
                                                <Typography>{field?.value ?? ""}</Typography>
                                            }
                                        />
                                    )}
                                    {renderGrid(
                                        "Почта",
                                        <Controller
                                            name="email"
                                            control={control}
                                            render={({ field }) =>
                                                <Typography>{field?.value ?? ""}</Typography>
                                            }
                                        />,
                                    )}
                                    {renderGrid(
                                        "Адрес",
                                        <Controller
                                            name="address"
                                            control={control}
                                            render={({ field }) =>
                                                <Typography>{field?.value ?? ""}</Typography>
                                            }
                                        />

                                    )}
                                    {renderGrid(
                                        "Номер телефона",
                                        <Controller
                                            name="phoneNumber"
                                            control={control}
                                            render={({ field }) =>
                                                <Typography>{field?.value ?? ""}</Typography>
                                            }
                                        />
                                    )}
                                    {renderGrid(
                                        "Иностранный студент",
                                        <Controller
                                            name="isForeign"
                                            control={control}
                                            render={({ field }) =>
                                                <Typography>{field?.value ? "Да" : "Нет"}</Typography>
                                            }
                                        />
                                    )}
                                    {renderGrid(
                                        "Баркод",
                                        <Controller
                                            name="barcode"
                                            control={control}
                                            render={({ field }) =>
                                                <Typography>{field?.value ?? ""}</Typography>
                                            }
                                        />
                                    )}
                                </Box>
                                <Box width={"100%"} mb="30px">
                                    <Box style={{
                                        marginBottom: 10,
                                        display: "flex",
                                        justifyContent: "center"
                                    }}>
                                        <Typography variant="h5">Информация удостоверения абитурента</Typography>
                                    </Box>
                                    {renderGrid(
                                        "Тип документа",
                                        <Controller
                                            name="docType"
                                            control={control}
                                            render={({ field }) =>
                                                <Typography>{`${field?.value?.name ?? ""} / ${field?.value?.nameEn ?? ""} / ${field?.value?.nameKz ?? ""}`}</Typography>
                                            }
                                        />,
                                    )}
                                    {renderGrid(
                                        "Номер документа",
                                        <Controller
                                            name="number"
                                            control={control}
                                            render={({ field }) =>
                                                <Typography>{field?.value ?? ""}</Typography>
                                            }
                                        />,
                                    )}
                                    {renderGrid(
                                        "Дата выдачи документа",
                                        <Controller
                                            name="givenAt"
                                            control={control}
                                            render={({ field }) => (
                                                <Typography>{field?.value ?? ""}</Typography>
                                            )}
                                        />,
                                    )}
                                    {renderGrid(
                                        "Орган выдачи документа",
                                        <Controller
                                            name="authorityType"
                                            control={control}
                                            render={({ field }) =>
                                                <Typography>{`${field?.value?.name ?? ""} / ${field?.value?.nameEn ?? ""} / ${field?.value?.nameKz ?? ""}`}</Typography>
                                            }
                                        />,
                                    )}
                                </Box>
                                {abiturInfo.dateOfBirth && isUnder18 && (
                                    <Box width={"100%"} mb="30px">
                                        <Box style={{
                                            marginBottom: 10,
                                            display: "flex",
                                            justifyContent: "center"
                                        }}>
                                            <Typography variant="h5">Информация родителя/опекуна</Typography>
                                        </Box>

                                        {renderGrid(
                                            `ФИО родителя/опекуна`,
                                            <Controller
                                                name="parentFullname"
                                                control={control}
                                                render={({ field }) =>
                                                    <Typography>{field?.value ?? ""}</Typography>
                                                }
                                            />,
                                        )}
                                        {renderGrid(
                                            "Почта родителя/опекуна",
                                            <Controller
                                                name="parentEmail"
                                                control={control}
                                                defaultValue={""}
                                                render={({ field }) =>
                                                    <TextField
                                                        {...field}
                                                        variant="outlined"
                                                        placeholder='Введите ваш email'
                                                        fullWidth
                                                        required
                                                        margin="normal"
                                                    />
                                                }
                                            />,
                                        )}
                                        {renderGrid(
                                            "ИИН",
                                            <Controller
                                                name="parentIIN"
                                                control={control}
                                                defaultValue={""}
                                                render={({ field }) =>
                                                    <TextField
                                                        {...field}
                                                        variant="outlined"
                                                        placeholder='Введите ИИН'
                                                        fullWidth
                                                        required
                                                        margin="normal"
                                                        inputProps={{ maxLength: 12 }}
                                                    />
                                                }
                                            />,
                                        )}
                                        {renderGrid(
                                            "Тип документа",
                                            <Controller
                                                name="parentDocType"
                                                control={control}
                                                defaultValue={""}
                                                render={({ field: { onChange, value }, fieldState: { error } }) =>
                                                    <TextField
                                                        select
                                                        variant="outlined"
                                                        required
                                                        fullWidth
                                                        value={value ? value.id : ''}
                                                        onChange={(e) => onChange({ id: e.target.value })}
                                                        error={!!error}
                                                    >
                                                        {documents.map((document) => (
                                                            <MenuItem
                                                                key={document.id}
                                                                value={document.id}
                                                            >
                                                                {document.name}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                }
                                            />,
                                        )}
                                        {renderGrid(
                                            "Орган выдачи документа",
                                            <Controller
                                                name="parentDocInstitution"
                                                control={control}
                                                defaultValue={""}
                                                render={({ field: { onChange, value }, fieldState: { error } }) =>
                                                    <TextField
                                                        select
                                                        variant="outlined"
                                                        required
                                                        fullWidth
                                                        defaultValue={1}
                                                        value={value ? value.id : ""}
                                                        onChange={(e) => onChange({ id: e.target.value })}
                                                        error={!!error}
                                                    >
                                                        {institutions.map((institution) => (
                                                            <MenuItem
                                                                key={institution.id}
                                                                value={institution.id}
                                                            >
                                                                {institution.name}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                }
                                            />,
                                        )}
                                        {renderGrid(
                                            "Номер документа",
                                            <Controller
                                                name="parentDocNumber"
                                                control={control}
                                                defaultValue={""}
                                                render={({ field }) =>
                                                    <TextField
                                                        {...field}
                                                        variant="outlined"
                                                        placeholder='Введите номер документа'
                                                        fullWidth
                                                        required
                                                        margin="normal"
                                                    />
                                                }
                                            />,
                                        )}
                                        {renderGrid(
                                            "Дата выдачи документа",
                                            <Controller
                                                name="parentDocGivenAt"
                                                control={control}
                                                defaultValue=""
                                                render={({ field: { onChange, value }, fieldState: { error } }) => (
                                                    <TextField
                                                        value={value || ""}
                                                        onChange={onChange}
                                                        variant="outlined"
                                                        fullWidth
                                                        required
                                                        type="date"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        error={!!error}
                                                    />
                                                )}
                                            />,
                                        )}
                                    </Box>
                                )}
                                <Box width={"100%"} mb="30px">
                                    <Box style={{
                                        marginBottom: 10,
                                        display: "flex",
                                        justifyContent: "center"
                                    }}>
                                        <Typography variant="h5">Сведения о поступлении</Typography>
                                    </Box>

                                    {renderGrid(
                                        "Год поступления",
                                        <Controller
                                            name="admissionYear"
                                            control={control}
                                            defaultValue={""}
                                            render={({ field }) =>
                                                <Typography>{field?.value ?? ""}</Typography>
                                            }
                                        />,
                                    )}
                                    {renderGrid(
                                        "Академическая степень",
                                        <Controller
                                            name="degree"
                                            control={control}
                                            render={({ field }) =>
                                                <Typography>{`${field?.value?.name ?? ""} / ${field?.value?.nameEn ?? ""} / ${field?.value?.nameKz ?? ""}`}</Typography>
                                            }
                                        />
                                    )}
                                    {renderGrid(
                                        "Название ГОП",
                                        <Controller
                                            name="goep"
                                            control={control}
                                            render={({ field }) =>
                                                <Typography>{`${field?.value?.name ?? ""} / ${field?.value?.nameEn ?? ""} / ${field?.value?.nameKz ?? ""} ${field?.value?.educationalProgramCode ? `- (${field?.value?.educationalProgramCode})` : ""}`}</Typography>
                                            }
                                        />,
                                    )}
                                    {renderGrid(
                                        "Название ОП",
                                        <Controller
                                            name="ep"
                                            control={control}
                                            render={({ field }) =>
                                                <Typography>{`${field?.value?.name ?? ""} / ${field?.value?.nameEn ?? ""} / ${field?.value?.nameKz ?? ""} ${field?.value?.code ? `- (${field?.value?.code})` : ""}`}</Typography>
                                            }
                                        />,
                                    )}
                                    {renderGrid(
                                        "Присужденная степень",
                                        <Controller
                                            name="awardedDegree"
                                            control={control}
                                            render={({ field }) =>
                                                <Typography>{`${field?.value?.name ?? ""} / ${field?.value?.nameEn ?? ""} / ${field?.value?.nameKz ?? ""}`}</Typography>
                                            }
                                        />,
                                    )}

                                    {renderGrid(
                                        "Грант",
                                        <Controller
                                            name="isGrant"
                                            control={control}
                                            render={({ field }) =>
                                                <Typography>{field?.value ? "Да" : "Нет"}</Typography>
                                            }
                                        />,
                                    )}
                                </Box>
                            </Grid>
                        </DialogContentText>
                    </DialogContent>
                    {isLoading ? <CircularProgress /> :
                        <DialogActions>
                            <Button onClick={handleClose}>Закрыть</Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleSubmit(onDownload)}
                            >
                                Скачать шаблон
                            </Button>
                            <TextField
                                select
                                variant="outlined"
                                color="primary"
                                required
                                value={selectedLanguage}
                                onChange={handleLanguageChange}
                            >
                                <MenuItem value="none" disabled>
                                    Скачать заявление
                                </MenuItem>
                                {languages.map((lang) => (
                                    <MenuItem
                                        key={lang.id}
                                        value={lang.code}
                                    >
                                        {lang.name}
                                    </MenuItem>
                                ))}
                            </TextField>
                            {isHasContract
                                ?
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    target="_blank"
                                    href={`https://api.podpishi.kz/qr.php?id1=${contract.podpishiDocNum}&id2=${contract.podpishiDocHash}`}
                                >
                                    Посмотреть договор
                                </Button>
                                :
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    disabled={isHasContract}
                                >
                                    Отправить на подпись
                                </Button>
                            }

                        </DialogActions>
                    }
                </form>

            </Dialog >
        </>
    )
}

export default ContractModal